export const GET_CARDS = "GET_CARDS";
export const GET_CATEGORIES = "GET_CATEGORIES";
